<template>
  <div class="ticket_root">
    <head-top head-title="查看票根" go-back="true"></head-top>
    <img v-if="img!==''" :src="img" alt="" width="100%" height="100%">
    <p v-if="img===''"
       style="padding:200px 10px 0px 10px; text-align: center; font-size:16px">
      对不起，该项投票已领取表决票或已由同套房屋的其他业主完成</p>
  </div>
</template>
<style lang="scss">
  .ticket_root {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 0;
  }
</style>
<script>
  import headTop from '../header/Header.vue'

  export default {
    name: 'TicketRoot',
    data () {
      return {
        img: ''
      }
    },
    created () {
      // console.log(this.$route.params.url)
      this.img = this.$route.params.url
    },
    components: {
      headTop
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/TicketRoot.vue